module.exports = __webpack_public_path__ + "img/four-one.9dde56b0.png";